const win: any = window
win.EMP_ADAPTER_REACT = win.BIGO_NOVA_REACT
win.ReactDOM = win.EMP_ADAPTER_REACT.ReactDOM
win.ReactRouterDOM = win.EMP_ADAPTER_REACT.ReactRouterDOM
win.React = win.EMP_ADAPTER_REACT.React

import('./bootstrap').then(({mountApp}) => mountApp())
